import {gql} from "@apollo/client";
import {ComponentProps} from "react";
import ProjectCard from "../../components/ProjectCard";
import ChallengeCard from "../../components/ChallengeCard";
import {Project, Challenge, ChallengeEducationState} from "../../schema";

export type QueryData = {
  items: (
    Pick<Challenge, "__typename"> & ComponentProps<typeof ChallengeCard>["challenge"] |
    Pick<Project, "__typename"> & ComponentProps<typeof ProjectCard>["project"])[];
  challengesStates: (Pick<ChallengeEducationState, "__typename" | "challengeId" | "isCompleted"> &
    ComponentProps<typeof ChallengeCard>["challengeState"])[];
};

export const query = gql`
  query PlayerIndexSceneQuery {
    items: getAssignedChallenges {
      __typename
      ...ChallengeCard
      ...ProjectCard
    }

    challengesStates: getChallengesEducationState {
      __typename
      challengeId
      ...ChallengeCardState
    }
  }
  ${ChallengeCard.fragments.root}
  ${ChallengeCard.fragments.state}
  ${ProjectCard.fragments.root}
`;
